import { useEffect, useRef } from "react";
import { animate, useInView, useMotionValue, useTransform, motion, useReducedMotion } from "motion/react";

/** Counts from 0 to `to` the first time it scrolls into view. */
export default function CountUp({ to, prefix = "", suffix = "", duration = 1.6 }) {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, amount: 0.6 });
  const reduce = useReducedMotion();
  const mv = useMotionValue(reduce ? to : 0);
  const text = useTransform(mv, (v) => `${prefix}${Math.round(v)}${suffix}`);

  useEffect(() => {
    if (!seen || reduce) return;
    const c = animate(mv, to, { duration, ease: [0.16, 1, 0.3, 1] });
    return () => c.stop();
  }, [seen, reduce, to, duration, mv]);

  return <motion.span ref={ref}>{text}</motion.span>;
}
